import { SVGProps } from 'react';

const Heading1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 12h8m-8 6V6m8 12V6m5 6 3-2v8"
    />
  </svg>
);
export default Heading1;
